///<reference path="../../../../../typings/index.d.ts"/>
///<reference path="../short-cuts.module.ts"/>


module Meevo.Components.ShortCuts {
    "use strict";


    export class MeevoHotkeyRepeat implements angular.IDirective {
        restrict = "E";
        scope = {
            hotkeys: '=?'
        }
        private identityService: Meevo.Components.Common.IIdentityService;
        templateUrl = "app/components/short-cuts/directives/cheatSheetRepeatTemplate.html";

        constructor(private shortKeysListService: IShortCutsListService,
            protected $state: ng.ui.IStateService, identityService) {
            this.identityService = identityService;
        }


        link = (scope: any, element: JQuery, attrs: angular.IAttributes) => {


            scope.hotkeyCategorys = {
                "global": {
                    'key': 'menu', 'description': 'Menu Items', 'currentCategory': false
                },
                'appointmentBook': {
                    'key': 'appointmentBook', 'description': 'Appointment Book', 'listKey': 'HOTKEY_COMBO_APPOINTMENT_BOOK', 'currentCategory': false
                },
                'appointmentEditor': {
                    'key': 'appointmentEditor', 'description': 'Appointment Editor', 'currentCategory': false
                },
                'register': {
                    'key': 'register', 'description': 'Register', 'listKey': 'HOTKEY_COMBO_REGISTER', 'currentCategory': false
                },
                'dataEntry': {
                    'key': 'dataEntry', 'description': 'Data Entry', 'currentCategory': false
                },
                'popupWindow': {
                    'key': 'popupWindow', 'description': 'Pop-up Window', 'currentCategory': false

                }
            };

            scope.currentHotkeys = [];

            //home - smart center global hotkey set
            //data entry - all pages except, client business type. show hotkey library repeat
            //
            //scope.showDefaultHotkeys = false;

            scope.$on('$stateChangeSuccess',
                (event, toState, toParams, fromState) => {
                    scope.stateName = toState.name;
                    //scope.showDefaultHotkeys = false;
                    if (isValidHotkeyCategory(scope.stateName)) {
                        //appointmentBook, register
                        scope.getCategoryHotkeys(scope.stateName);

                    }
                    else if (toState.name == 'home') {

                        scope.hideCurrentHotkeys = true;
                        scope.getCategoryHotkeys('menu');
                    }
                    else {
                        //data maintenance screen. display 
                        scope.hideCurrentHotkeys = false;
                        scope.getCategoryHotkeys('dataEntry', true);
                    }
                    //if (fromState.name === stateName) {
                    //    this.
                    //} else if (toState.name === stateName) {
                    //}
                });

            function isValidHotkeyCategory(category) {
                if (_.contains(Object.keys(scope.hotkeyCategorys), category)) {
                    return true;
                }
                return false;
            }

            var getHotkeys = (categoryList) => {
                let that = this;
                var category = {};

                //_.each(category, function (hotkey) {
                //    scope.currentHotkeys.push(that.shortKeysListService.get(hotkey))

                //})
            }
            scope.retrieveKey = (key) => {
                if (!_.isUndefined(key)) {
                    return this.shortKeysListService.get(key);
                }

            }
            scope.openCategory = (item) => {
                _.forEach(scope.hotkeyCategorys, function (category: any) {
                    if (category.key == item) {
                        category.currentCategory = true;
                    } else {

                        category.currentCategory = false;
                    }
                })
            }

            scope.getCategoryHotkeys = (stateName, overrideCurrentHotkeys = false) => {

                if (overrideCurrentHotkeys && stateName != this.$state.current.name) {
                    scope.hideCurrentHotkeys = true;
                } else {
                    scope.hideCurrentHotkeys = false;
                }
                let that = this;
                scope.openCategory(stateName);
                //if (stateName == this.$state.current.name) return;

                switch (stateName) {
                    case 'appointmentBook':
                        scope.currentHotkeys = this.shortKeysListService.getByType('APPOINTMENT_BOOK_');
                        break;
                    case 'appointmentEditor':
                        scope.currentHotkeys = this.shortKeysListService.getByType('APPT_EDITOR_');
                        break;
                    case 'register':
                        scope.currentHotkeys = this.shortKeysListService.getByType('REGISTER_');
                        //getHotkeys(stateName);
                        break;
                    case 'dataEntry':
                        scope.currentHotkeys = this.shortKeysListService.getByType('DATA_MAINTENANCE_');
                        break;
                    case 'popupWindow':
                        scope.currentHotkeys = this.shortKeysListService.getByType('MODAL_');
                        break;
                    case 'global':
                        scope.globalHotkeys = this.shortKeysListService.getByType('GLOBAL_');
                       
                    case 'menu':
                    default:
                          
                        if (typeof (this.identityService.current()) !== 'undefined'){
                               if (this.identityService.isSingleLocation()) {
                                scope.globalHotkeys.splice(scope.globalHotkeys.indexOf(4), 1);
                            }
                        }
                        //show menu hotkeys
                        scope.currentHotkeys = this.shortKeysListService.getByType('HOTKEY_COMBO')
                        //getHotkeys('global');
                        break;
                }
            }
            scope.getCategoryHotkeys('global');

            scope.isCategoryCurrent = (category) => {


                if (this.$state.current.name == category) {

                    //appointment book/register
                    return true;
                } else if (this.$state.current.name == 'home' && category == 'menu') {
                    //home
                    return true;
                } else if (category == 'dataEntry' && scope.stateName != 'register' && scope.stateName != 'appointmentBook' && scope.stateName != 'home') {
                    //assuming it is a data maintenance form
                    //display data maint hotkey group
                    return true;
                }
                else return false;
            }







        }

        static factory(): angular.IDirectiveFactory {
            let directive = (shortKeyListService: IShortCutsListService, $state: ng.ui.IStateService, identityService) => {
                return new MeevoHotkeyRepeat(shortKeyListService, $state, identityService);
            };

            directive.$inject = ['meevo.components.short-cuts.ShortCutsListService', '$state', 'meevo.components.common.IdentityService'];

            return directive;
        }
    }

    angular.module("meevo.components.short-cuts")
        .directive("meevoHotkeyRepeat", MeevoHotkeyRepeat.factory());

    export function hotkeyFilterGeneral($filter: any): any {
        const filter = (input: any) => {
            //let output = [];
            var output = [];
            if (!input) {
                return output;
            }
            _.each(input, function (item) {
                if ((item as any).description.toString() != 'Open menu'
                    && (item as any).description.toString() != 'Help'
                    && (item as any).description.toString() != 'Lock out session'
                    && (item as any).description.toString() != 'Find'
                    && (item as any).description.toString() != '$$undefined$$'
                    && (item as any).description.toString() != 'Show / hide this help menu') {
                    output.push(item);
                }
            })

            return output;
        }

        return filter;
    }

    hotkeyFilterGeneral.$inject = ['$filter'];

    angular.module("meevo.components.short-cuts")
        .filter("hotkeyFilterGeneral", hotkeyFilterGeneral)
}